import ContactsVue from '@/views/sic/contacts/contacts.vue';

const basePath = '/sic/contacts';
const role = 'sic'; // 角色身份

export const SIC_CONTACTS_INDEX = 'sic-contacts-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ContactsVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_CONTACTS_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/contacts/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
